import React from 'react';
import {Col, Form, Row} from "antd";
import {t, Trans} from "@lingui/macro";
import ToggleToEdit from "../../ToggleToEdit";
import { Select } from '../../DataEntry';

const { Option } = Select;

export function ChartOfAccountFormItem(props) {
    const { size, accountSets, keepOpenAfterToggle, onToggleOpen } = props;

    const renderNotToggled = toggleOpen => (
        <Row type="flex">
            <Col span={24} style={{fontSize: 13}}>
                <Trans>
                    {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                    Chart of Accounts is set to <strong>General</strong>.
                </Trans>
                &nbsp;
                <span
                    className="link"
                    onClick={() => {
                        toggleOpen();
                    }}
                >
                    <Trans>Change</Trans>
                </span>
                <Form.Item name="account_set" initialValue="GENERAL" noStyle>
                    <span />
                </Form.Item>
            </Col>
        </Row>
    );

    const getAccountSetLabel = acc => {
        switch (acc) {
            case 'DUMMY':
                return <Trans>Dummy</Trans>;
            case 'GENERAL':
            default:
                return <Trans>General</Trans>;
        }
    };

    const formItem = (
        <Row type="flex">
            <Col span={24}>
                <Form.Item
                    name="account_set"
                    label={t`Chart of Account`}
                    rules={[{
                        required: true,
                        message: t`Chart of Account is required.`,
                    }]}
                    initialValue="GENERAL"
                >
                    <Select
                        placeholder={t`Select Chart of Account`}
                        dropdownMatchSelectWidth={false}
                        allowClear={false}
                        showSearch
                        filterOption
                        optionFilterProp="label"
                        popupContainerId="parentElement"
                        size={size || 'medium'}
                    >
                        {accountSets?.map(acc => (
                            <Option value={acc} key={acc}>
                                {getAccountSetLabel(acc)}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
        </Row>
    );

    // used in partner create client modal, to keep the form item in edit mode
    if (keepOpenAfterToggle)
        return formItem;

    return (
        <ToggleToEdit renderNotToggled={renderNotToggled} onToggleOpen={onToggleOpen}>
            {formItem}
        </ToggleToEdit>
    );
}
